
import * as THREE from "three"


export default class Mask {

    constructor(texture,width,height) {

        this.geometry = new THREE.PlaneGeometry(width, height, 1, 1)

        texture.wrapS = THREE.RepeatWrapping
        texture.wrapT = THREE.RepeatWrapping
        //texture.repeat.set(1,-1)

        this.material = new THREE.MeshBasicMaterial({
            map: texture,
            //alphaMap: texture,
            //side: THREE.DoubleSide,
            transparent: true,
            alphaTest: 0.45, // 1 bad - mask // @rendering
        })

        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )

    }



    getMesh() {

        return this.mesh

    }


    /**
     * modify texture
     * @param texture
     */
    modifyTexture( texture ) {

        // @todo
        this.mesh.material.map = texture
        //this.mesh.material.map.needsUpdate = true
        //this.mesh.material.needsUpdate = true

    }

}